const SERVER_URL = 'https://rfemfo.co.kr/';

const isMobile = () => {return window.innerWidth <= 767;};

export { SERVER_URL, isMobile };
